import { defineConfig } from '../config'
import { authHeader } from '../helpers';
import { utilsService } from './utils'
const { handleResponse, handleResponseBlob } = utilsService

export const systemsService = {
  getApiPath,
  getAllMediaOwners,
  getAllAreaSystems,
  getAllSystemCodes,
  getAllMunicipalities,
  createSystem,
  getSystemById,
  getFramesBySystemId,
  createFrames,
  updateFrames,
  updateSystem,
  deleteSystem,
  getAllSystemTypes,
  getSystemTypeById,
  createSystemType,
  updateSystemType,
  deleteSystemType,
  uploadImage,
  addImageToSystem,
  deleteImage,
  getSystemSuggestions,
  getImage,
  getImageBySystemId,
  getMunicipalityById,
  createSystemTypeDimensions,
  getSystemTypeDimensionById,
  getAllSystemTypeDimensionByTypeId,
  updateSystemTypeDimensions,
  deleteSystemTypeDimensions,
  getSystemSuggestionsNoPagination,
  getAllSystemTeamsPaged,
  getAllSystemTeams,
  getSystemTeamById,
  updateSystemTeam,
  createSystemTeam,
  deleteSystemTeam,
  createSystemTeamManagement,
  updateSystemTeamManagement,
  getSystemTeamDuties,
  deleteSystemTeamManagement,
  getSystemTeamManagementsBySystem,
  getDevicesBySystemId,
  createDevices,
  updateDevices,
  getSuggestions,
  getAllAuditsPaged,
  createAudit,
  updateAudit,
  deleteAudit,
  getAuditSystemCodes,
  getAllCompliances,
  createCompliance,
  updateCompliance,
  deleteCompliance,
  connectCompliances,
  disconnectCompliance,
  getAllPowerSupplies,
  saveElectricalSystem,
  getElectricalSystem,
  createPowerSupply,
  updatePowerSupply,
  deletePowerSupply,
  getElectricalSystemsByPowerSupplyId,
  getDashboardSummary,
  getDashboardToCheck,
  getSystemAudience,
  getAvailability,
  getOccupancy,
  getOccupancyPriceTrend,
  getSearchFilterOptions,
  getPivotDimensions,
  getPivot,
  importAppesoImage
};

const { apiUrl, apiVer } = defineConfig.SYSTEMS_SERVICE;

function getApiPath() {
  return (apiUrl + apiVer + "/system")
}

function getTeamApiPath() {
  return (apiUrl + apiVer + "/system/team")
}

function getTeamManagementApiPath() {
  return (apiUrl + apiVer + "/system/team/management")
}

function getImageApiPath() {
  return (apiUrl + apiVer + "/system/image")
}

function getMediaOwnerApiPath() {
  return (apiUrl + apiVer + "/mediaOwner")
}

function getFrameApiPath() {
  return (apiUrl + apiVer + "/system/frame")
}

function getDeviceApiPath() {
  return apiUrl + apiVer + "/system/device";
}

function getTypeApiPath() {
  return (apiUrl + apiVer + "/system/type")
}

function getProjectApiPath() {
  return (apiUrl + apiVer + "/project")
}

function getPowerSupplyApiPath() {
  return (apiUrl + apiVer + "/system/electrical/power-supply")
}

/** Stores a photo and adds it to the images of the system in one step (the cover when it has none) */
function addImageToSystem(systemId, file) {
  const formData = new FormData();
  formData.append('file', file);
  return fetch(getImageApiPath() + "/create/system/" + encodeURIComponent(systemId), { method: "POST", headers: authHeader(), body: formData })
    .then(response => response.ok ? response.json() : response.text().then(text => Promise.reject(text || response.statusText)));
}

function uploadImage(file) {
  const url = getImageApiPath() + "/create";
  const formData = new FormData();

  formData.append('file', file);

  const requestOptions = {
    method: "POST",
    headers: authHeader(),
    body: formData
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
};

function getImage(id) {
  const url = getImageApiPath() + "/read/" + id;

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };
  return fetch(
    url,
    requestOptions
  )
    .then(handleResponseBlob)
    .then(blob => {
      if (!blob) {
        return null;
      }
      return URL.createObjectURL(blob);
    })
    .then(res => {
      return res;
    });
}

function getImageBySystemId(systemId) {
  const url = getImageApiPath() + "/read/system/" + systemId;

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };
  return fetch(
    url,
    requestOptions
  )
    .then(handleResponseBlob)
    .then(blob => {
      if (!blob) {
        return null;
      }
      return URL.createObjectURL(blob);
    })
    .then(res => {
      return res;
    });
}

function deleteImage(id) {
  const url = getImageApiPath() + "/delete/" + id;

  const requestOptions = {
    method: "DELETE",
    headers: authHeader(),
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
};

function getAllSystemTeamsPaged(page, perPage, companyName = '', address = '', vat = '', mail = '', type = [], phone = '', sortOrder = 'ASC') {
  const url = getTeamApiPath() + "/all/" + page + "/" + perPage;

  const body = {
    companyName: companyName,
    address: address,
    vat: vat,
    SystemTeamManagementType: type,
    mail: mail,
    phone: phone,
    sortOrder: sortOrder
  }

  const requestOptions = {
    method: "POST",
    headers: authHeader("application/json"),
    body: JSON.stringify(body)
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function getAllAuditsPaged(page, perPage) {
  const url = getApiPath() + "/verifiche/all/" + page + "/" + perPage;

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(url, requestOptions)
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function createAudit(body) {
  const url = getApiPath() + "/verifiche/create";

  const requestOptions = {
    method: "POST",
    headers: authHeader("application/json"),
    body: JSON.stringify(body)
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => res);
}

function updateAudit(id, body) {
  const url = getApiPath() + "/verifiche/update";

  const payload = {
    ...body,
    id: id
  };

  const requestOptions = {
    method: "PUT",
    headers: authHeader("application/json"),
    body: JSON.stringify(payload)
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => res);
}

function deleteAudit(id) {
  const requestOptions = {
    method: 'DELETE',
    headers: authHeader('application/json')
  };

  return fetch(getApiPath() + `/audit/delete/${id}`, requestOptions)
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function getAuditSystemCodes() {
  const url = getApiPath() + "/all/code/verifiche";

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(url, requestOptions)
    .then(handleResponse)
    .then(res => res);
}

function getAllSystemTeams() {
  const url = getTeamApiPath() + "/all";
  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function getSystemTeamById(id) {
  const url = getTeamApiPath() + "/read/" + id;

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function updateSystemTeam(body, id) {
  const url = getTeamApiPath() + "/update/" + id;

  const requestOptions = {
    method: "PUT",
    headers: authHeader("application/json"),
    body: JSON.stringify(body)
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function createSystemTeam(body) {
  const url = getTeamApiPath() + "/create";

  const requestOptions = {
    method: "POST",
    headers: authHeader("application/json"),
    body: JSON.stringify(body)
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function deleteSystemTeam(id) {
  const url = getTeamApiPath() + "/delete/" + id;

  const requestOptions = {
    method: "DELETE",
    headers: authHeader("application/json"),
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function getSystemTeamDuties() {
  const url = getTeamApiPath() + "/all/duty";

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function createSystemTeamManagement(body) {
  const url = getTeamManagementApiPath() + "/create";

  const requestOptions = {
    method: "POST",
    headers: authHeader("application/json"),
    body: JSON.stringify(body)
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function updateSystemTeamManagement(body) {
  const url = getTeamManagementApiPath() + "/update";

  const requestOptions = {
    method: "PUT",
    headers: authHeader("application/json"),
    body: JSON.stringify(body)
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function getSystemTeamManagementsBySystem(systemId) {
  const url = getTeamManagementApiPath() + "/all/" + systemId;

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function deleteSystemTeamManagement(systemTeamManagementId) {
  const url = getTeamManagementApiPath() + "/delete/" + systemTeamManagementId;

  const requestOptions = {
    method: "DELETE",
    headers: authHeader("application/json"),
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function getAllMediaOwners() {
  const url = getMediaOwnerApiPath() + "/all";

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function getFramesBySystemId(systemId) {
  const url = getFrameApiPath() + "/all/" + systemId;

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function createFrames(frameData, systemId) {
  const url = getFrameApiPath() + "/create/all/" + systemId

  const requestOptions = {
    method: "POST",
    headers: authHeader("application/json"),
    body: JSON.stringify(frameData),
  };

  return fetch(url, requestOptions)
    .then(handleResponse)
    .then((res) => res);
}

function updateFrames(frameData, systemId) {
  const url = getFrameApiPath() + "/update/" + systemId

  const requestOptions = {
    method: "PUT",
    headers: authHeader("application/json"),
    body: JSON.stringify(frameData),
  };

  return fetch(url, requestOptions)
    .then(handleResponse)
    .then((res) => res);
}

function getDevicesBySystemId(systemId) {
  const url = getDeviceApiPath() + "/all/" + systemId;

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(url, requestOptions)
    .then(handleResponse)
    .then((res) => res);
}

function createDevices(deviceData, systemId) {
  const url = getDeviceApiPath() + "/create/all/" + systemId;

  const requestOptions = {
    method: "POST",
    headers: authHeader("application/json"),
    body: JSON.stringify(deviceData),
  };

  return fetch(url, requestOptions)
    .then(handleResponse)
    .then((res) => res);
}

function updateDevices(deviceData, systemId) {
  const url = getDeviceApiPath() + "/update/" + systemId;

  const requestOptions = {
    method: "PUT",
    headers: authHeader("application/json"),
    body: JSON.stringify(deviceData),
  };

  return fetch(url, requestOptions)
    .then(handleResponse)
    .then((res) => res);
}

function getAllMunicipalities() {
  const url = getApiPath() + "/all/municipality";

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function getAllAreaSystems() {
  const url = getApiPath() + "/all/area";

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function getAllSystemCodes(searchTerm = "", searchField = "fullAddress", type = "ALL", filters = {}, overrideCategory = null) {
  const newType = overrideCategory ? `&${overrideCategory}` : `&type=${type}`;
  const url = getApiPath() + `/all/codes?searchTerm=${encodeURIComponent(searchTerm)}&searchField=${searchField}${newType}`;

  const requestOptions = {
    method: "POST",
    headers: authHeader("application/json"),
    body: JSON.stringify(filters)
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function getSystemById(id) {
  const url = getApiPath() + "/read/" + id;

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function updateSystem(system) {
  const url = getApiPath() + "/update/" + system.id + "/" + system.type;
  const requestOptions = {
    method: "POST",
    headers: authHeader("application/json"),
    body: JSON.stringify(system)
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function createSystem(system) {
  const { type } = system;
  const url = getApiPath() + "/create/" + type;
  const requestOptions = {
    method: "POST",
    headers: authHeader("application/json"),
    body: JSON.stringify(system)
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function deleteSystem(systemId) {
  const url = getApiPath() + "/delete/" + systemId;

  const requestOptions = {
    method: "DELETE",
    headers: authHeader("application/json"),
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function createSystemType(systemType) {
  const url = getTypeApiPath() + "/create";

  const requestOptions = {
    method: "POST",
    headers: authHeader("application/json"),
    body: JSON.stringify(systemType)
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function updateSystemType(systemType) {
  const url = getTypeApiPath() + "/update?id=" + systemType.id;

  const requestOptions = {
    method: "PUT",
    headers: authHeader("application/json"),
    body: JSON.stringify(systemType)
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function deleteSystemType(id) {
  const url = getTypeApiPath() + "/delete/" + id;

  const requestOptions = {
    method: "DELETE",
    headers: authHeader("application/json"),
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function getSystemTypeById(id) {
  const url = getTypeApiPath() + "/" + id;

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function getAllSystemTypes(channel = "ALL") {
  const url = getTypeApiPath() + "/all/" + channel;

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function getMunicipalityById(id) {
  const url = getApiPath() + "/read/municipality/" + id;

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function getSystemSuggestions(searchTerm, searchField, page = 0, size = 20, sortBy = "creationDate", sortDir = "descend", type = "ALL", filters = {}, overrideCategory = null) {
  const newType = overrideCategory ? `&${overrideCategory}` : `&type=${type}`

  const url = getApiPath() + `/all/suggestion?searchTerm=${encodeURIComponent(searchTerm)}&searchField=${searchField}&page=${page}&size=${size}&sortBy=${sortBy}&sortDir=${sortDir}${newType}`;

  const requestOptions = {
    method: "POST",
    headers: authHeader("application/json"),
    body: JSON.stringify(filters)
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function getSystemSuggestionsNoPagination(searchTerm, searchField, sortBy = "creationDate", sortDir = "descend", type = "ALL", filters = {}, overrideCategory = null) {
  const newType = overrideCategory ? `&${overrideCategory}` : `&type=${type}`

  const url = getApiPath() + `/all/suggestion/map?searchTerm=${encodeURIComponent(searchTerm)}&searchField=${searchField}&sortBy=${sortBy}&sortDir=${sortDir}${newType}`;

  const requestOptions = {
    method: "POST",
    headers: authHeader("application/json"),
    body: JSON.stringify(filters)
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function getSuggestions(searchTerm) {
  /*   const url = apiUrl + "v1/search/system/all/suggestion/" + searchTerm;
    
    const requestOptions = {
      method: "GET",
      headers: authHeader("application/json"),
    };
  
    return fetch(
      url,
      requestOptions
    )
      .then(handleResponse)
      .then(res => {
        return res;
      }); */
}

function createSystemTypeDimensions(dimension) {
  const url = getTypeApiPath() + "/dimension/create";

  const requestOptions = {
    method: "POST",
    headers: authHeader("application/json"),
    body: JSON.stringify(dimension)
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function getSystemTypeDimensionById(id) {
  const url = getTypeApiPath() + "/dimension/" + id;

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function getAllSystemTypeDimensionByTypeId(typeId) {
  const url = getTypeApiPath() + "/dimension/all/" + typeId;

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function updateSystemTypeDimensions(id, dimension) {
  const url = getTypeApiPath() + "/dimension/update/" + id;

  const requestOptions = {
    method: "PUT",
    headers: authHeader("application/json"),
    body: JSON.stringify(dimension)
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function deleteSystemTypeDimensions(id) {
  const url = getTypeApiPath() + "/dimension/delete/" + id;

  const requestOptions = {
    method: "DELETE",
    headers: authHeader("application/json")
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

// COMPLIANCE / PROGETTI

function getAllCompliances() {
  const url = getProjectApiPath() + `/all`;

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(url, requestOptions)
    .then(handleResponse)
    .then((res) => {
      return res;
    });
}

function createCompliance(body) {
  const url = getProjectApiPath() + `/create`;

  const requestOptions = {
    method: "POST",
    headers: authHeader("application/json"),
    body: JSON.stringify(body),
  };

  return fetch(url, requestOptions)
    .then(handleResponse)
    .then((res) => {
      return res;
    });
}

function updateCompliance(id, body) {
  const url = getProjectApiPath() + `/update/${id}`;

  const requestOptions = {
    method: "PUT",
    headers: authHeader("application/json"),
    body: JSON.stringify(body),
  };

  return fetch(url, requestOptions)
    .then(handleResponse)
    .then((res) => {
      return res;
    });
}

function deleteCompliance(id) {
  const url = getProjectApiPath() + `/delete/${id}`;

  const requestOptions = {
    method: "DELETE",
    headers: authHeader("application/json"),
  };

  return fetch(url, requestOptions)
    .then(handleResponse)
    .then((res) => {
      return res;
    });
}

function connectCompliances(systemId, selectedCompliances) {
  const url = getProjectApiPath() + `/${systemId}/link`;

  const requestOptions = {
    method: "POST",
    headers: authHeader("application/json"),
    body: JSON.stringify({ complianceIds: selectedCompliances }),
  };

  return fetch(url, requestOptions)
    .then(handleResponse)
    .then((res) => {
      return res;
    });
}

function disconnectCompliance(systemId, projectId) {
  const url = getProjectApiPath() + `/${projectId}/unlink/${systemId}`;

  const requestOptions = {
    method: "DELETE",
    headers: authHeader("application/json"),
  };

  return fetch(url, requestOptions)
    .then(handleResponse)
    .then((res) => {
      return res;
    });
}

/** The electrical data of a system (rejects when it has none) */
function getElectricalSystem(systemId) {
  const url = apiUrl + apiVer + "/system/electrical/system/" + systemId;
  return fetch(url, { method: "GET", headers: authHeader("application/json") }).then(handleResponse);
}

/** Creates (exists = false) or updates the electrical data of a system */
function saveElectricalSystem(systemId, body, exists) {
  const url = apiUrl + apiVer + "/system/electrical/system/" + (exists ? "update/" : "create/") + systemId;
  const requestOptions = {
    method: exists ? "PUT" : "POST",
    headers: authHeader("application/json"),
    body: JSON.stringify(body)
  };
  return fetch(url, requestOptions).then(handleResponse);
}

function getAllPowerSupplies() {
  const url = getPowerSupplyApiPath() + "/all";

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(url, requestOptions)
    .then(handleResponse)
    .then(res => res);
}

function createPowerSupply(body) {
  const url = getPowerSupplyApiPath() + "/create";

  const requestOptions = {
    method: "POST",
    headers: authHeader("application/json"),
    body: JSON.stringify(body)
  };

  return fetch(url, requestOptions)
    .then(handleResponse)
    .then(res => res);
}

function updatePowerSupply(id, body) {
  const url = getPowerSupplyApiPath() + "/update/" + id;

  const requestOptions = {
    method: "PUT",
    headers: authHeader("application/json"),
    body: JSON.stringify(body)
  };

  return fetch(url, requestOptions)
    .then(handleResponse)
    .then(res => res);
}

function deletePowerSupply(id) {
  const url = getPowerSupplyApiPath() + "/delete/" + id;

  const requestOptions = {
    method: "DELETE",
    headers: authHeader("application/json"),
  };

  return fetch(url, requestOptions)
    .then(handleResponse)
    .then(res => res);
}

function getElectricalSystemsByPowerSupplyId(id) {
  const url = getPowerSupplyApiPath() + "/" + id + "/systems";

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(url, requestOptions)
    .then(handleResponse)
    .then(res => res);
}

function getDashboardSummary() {
  const url = getApiPath() + "/dashboard/summary";

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(url, requestOptions)
    .then(handleResponse)
    .then(res => res);
}

function getDashboardToCheck(limit = 10) {
  const url = getApiPath() + "/dashboard/to-check?limit=" + limit;

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(url, requestOptions)
    .then(handleResponse)
    .then(res => res);
}

// Resolves with { status, data }: 202 means AudiOutdoor is still computing the audience, retry later
function getSystemAudience(systemId, days = 30) {
  const url = getApiPath() + "/audience/" + systemId + "?days=" + days;

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(url, requestOptions).then(response =>
    response.text().then(text => {
      let data = null;
      try {
        data = text ? JSON.parse(text) : null;
      } catch (e) {
        data = { message: text };
      }
      if (response.status === 200 || response.status === 202) {
        return { status: response.status, data };
      }
      return Promise.reject({ status: response.status, message: data?.message || text });
    })
  );
}

// Imports the Appeso photo of the system as cover: { status: IMPORTED | ALREADY_PRESENT | NOT_AVAILABLE, image }
function importAppesoImage(systemId) {
  const url = getImageApiPath() + "/appeso/" + systemId;

  const requestOptions = {
    method: "POST",
    headers: authHeader("application/json"),
  };

  return fetch(url, requestOptions)
    .then(handleResponse)
    .then(res => res);
}

// Availability of the typologies by municipality and period, imported from the Alyante snapshot
function getAvailability() {
  const url = getApiPath() + "/availability";

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(url, requestOptions)
    .then(handleResponse)
    .then(res => res);
}

// Values of the systems search filters: comuni, Alyante formats and territories, occupancy year
/** Dimensions of the systems pivot: [{ key, label }] */
function getPivotDimensions() {
  return fetch(getApiPath() + "/pivot/dimensions", { method: "GET", headers: authHeader("application/json") })
    .then(handleResponse);
}

/**
 * Pivot of the systems of the list: rows = dimension keys, outermost first (up to 3), columns optional, measures among
 * SYSTEMS, FACES and OCCUPANCY; search term, field, channel and filters are the list ones. Resolves with
 * { columnLabels, total: { label, values: { MEASURE: { column | "": value } }, systems, children } }
 */
function getPivot({ rows, columns, measures, type = "ALL", searchTerm, searchField, filters = {} }) {
  const params = new URLSearchParams({ type });
  rows.forEach(r => params.append("rows", r));
  measures.forEach(m => params.append("measures", m));
  if (columns) params.append("columns", columns);
  if (searchTerm) params.append("searchTerm", searchTerm);
  if (searchField) params.append("searchField", searchField);
  return fetch(getApiPath() + "/pivot?" + params.toString(), {
    method: "POST",
    headers: authHeader("application/json"),
    body: JSON.stringify(filters),
  }).then(handleResponse);
}

function getSearchFilterOptions() {
  const url = getApiPath() + "/all/filter-options";

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(url, requestOptions)
    .then(handleResponse)
    .then(res => res);
}

// Sold value and sold fortnights by year and format, for the price trend; territory is optional
function getOccupancyPriceTrend(territory) {
  const params = territory ? "?" + new URLSearchParams({ territory }).toString() : "";
  const url = getApiPath() + "/occupancy/price-trend" + params;

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(url, requestOptions)
    .then(handleResponse)
    .then(res => res);
}

// Occupancy and sold value by system face and fortnight, imported from Alyante; Spring page
function getOccupancy({ year, fortnight, territory, municipality, typology, code, page = 0, perPage = 20 } = {}) {
  const params = new URLSearchParams({ page, perPage });
  Object.entries({ year, fortnight, territory, municipality, typology, code })
    .filter(([, value]) => value !== undefined && value !== null && value !== '')
    .forEach(([key, value]) => params.append(key, value));
  const url = getApiPath() + "/occupancy?" + params.toString();

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(url, requestOptions)
    .then(handleResponse)
    .then(res => res);
}
